import React from 'react';
import { MessageCircle } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const FloatingWhatsApp = () => {
  const handleWhatsAppClick = () => {
    window.open(companyInfo.whatsappLink, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 group"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={32} className="group-hover:scale-110 transition-transform" />
      <span className="absolute -top-2 -right-2 w-4 h-4 bg-red-500 rounded-full animate-pulse"></span>
    </button>
  );
};

export default FloatingWhatsApp;
